@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.status-card-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-right: 1px solid @shipment-status-card--border-color;
  padding: 5px;

  &:last-child {
    border: none;
  }
}

.content {
  padding-right: 5px;
}

.title {
  color: @shipment-status-card--title--text-color;
  margin-bottom: 3px;
  font-size: 12px;
}

.message {
  color: @shipment-status-card--message--text-color;
  font-size: 12px;
}
